/** @format */
import { NextRouter } from 'next/router';

import {
    CheckoutInBoundPaymentFormValues,
    PaymentOrOutbound,
} from '@toucan/client/core/checkout';

export function isInboundPaymentFormValues(
    paymentOrOutbound: PaymentOrOutbound
): paymentOrOutbound is CheckoutInBoundPaymentFormValues {
    if (typeof paymentOrOutbound !== 'object') {
        return false;
    }

    return (
        'paymentGateway' in paymentOrOutbound &&
        'checkoutType' in paymentOrOutbound
    );
}

export async function redirectToCheckoutUrl(router: NextRouter) {
    await router.replace(router, `${window.location.pathname}?type=checkout`);
}
